import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { blogPosts } from '../data/blogPosts';
import BlogPostCard from './blog/BlogPostCard';

const HEADER_INITIAL = { opacity: 0, y: 30 };
const HEADER_VISIBLE = { opacity: 1, y: 0 };
const HEADER_TRANSITION = { duration: 0.6 };

const Blog = () => {
  const { language, t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const posts = blogPosts[language];

  return (
    <section id="blog" className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(168,85,247,0.05),transparent_50%)]" />

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={HEADER_INITIAL}
          animate={isInView ? HEADER_VISIBLE : HEADER_INITIAL}
          transition={HEADER_TRANSITION}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-white via-purple-100 to-white bg-clip-text text-transparent">
              {t.blog.title}
            </span>
          </h2>
        </motion.div>

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post, index) => (
            <BlogPostCard
              key={post.id}
              post={post}
              index={index}
              isInView={isInView}
              readMoreLabel={t.blog.readMore}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
